"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSubscriptions = fetchSubscriptions;
exports.fetchSubscriptionsIfNeeded = fetchSubscriptionsIfNeeded;
exports.fetchSubscriptionStatusIfNeeded = fetchSubscriptionStatusIfNeeded;
exports.updateSubscriptionEnabled = updateSubscriptionEnabled;
exports.saveSubscriptions = saveSubscriptions;
exports.resetSubscriptions = resetSubscriptions;
exports.fetchSubscriptionsDefinitions = fetchSubscriptionsDefinitions;

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _q = _interopRequireDefault(require("q"));

var _SubscriptionsApiClient = _interopRequireDefault(require("lead-flows-ui/api/SubscriptionsApiClient"));

var _underscore = require("underscore");

var _Subscriptions = require("lead-flows-ui/selectors/Subscriptions");

function requestSubscriptionStatus() {
  return {
    type: _ActionTypes.REQUEST_SUBSCRIPTION_STATUS
  };
}

function recieveSubscriptionStatus(formGuid, response) {
  return {
    type: _ActionTypes.RECEIVE_SUBSCRIPTION_STATUS,
    payload: response,
    meta: {
      formGuid: formGuid
    }
  };
}

function errorSubscriptionStatus(payload) {
  return {
    type: _ActionTypes.ERROR_SUBSCRIPTION_STATUS,
    payload: payload,
    error: true
  };
}

function requestSubscriptions() {
  return {
    type: _ActionTypes.REQUEST_SUBSCRIPTIONS_BY_FORM_GUID
  };
}

function receiveSubscriptions(formGuid, subscriptions) {
  return {
    type: _ActionTypes.RECEIVE_SUBSCRIPTIONS_BY_FORM_GUID,
    payload: subscriptions,
    meta: {
      formGuid: formGuid
    }
  };
}

function errorSubscriptions(payload) {
  return {
    type: _ActionTypes.ERROR_SUBSCRIPTIONS_BY_FORM_GUID,
    payload: payload,
    error: true
  };
}

function submitSubscriptionChanges() {
  return {
    type: _ActionTypes.SAVE_SUBSCRIPTIONS
  };
}

function successSubscriptionChanges(formGuid, response) {
  return {
    type: _ActionTypes.SAVE_SUBSCRIPTIONS_SUCCESS,
    payload: response,
    meta: {
      formGuid: formGuid
    }
  };
}

function errorSubscriptionChanges(error) {
  return {
    type: _ActionTypes.SAVE_SUBSCRIPTIONS_ERROR,
    payload: error,
    error: true
  };
}

function changeSubcriptionEnabled(formGuid, espListId, syncEnabled) {
  return {
    type: _ActionTypes.CHANGE_SUBSCRIPTION_STATUS,
    payload: {
      formGuid: formGuid,
      espListId: espListId,
      syncEnabled: syncEnabled
    }
  };
}

function resetSubscriptionsAction() {
  return {
    type: _ActionTypes.RESET_SUBSCRIPTIONS
  };
}

function requestSubscriptionsDefinitions() {
  return {
    type: _ActionTypes.REQUEST_SUBSCRIPTIONS_DEFINITIONS
  };
}

function successSubscriptionDefinitions(definitions) {
  return {
    type: _ActionTypes.RECEIVE_SUBSCRIPTIONS_DEFINITIONS,
    payload: definitions
  };
}

function errorSubscriptionsDefinitions(error) {
  return {
    type: _ActionTypes.ERROR_SUBSCRIPTIONS_DEFINITIONS,
    payload: error
  };
}

function fetchSubscriptions(formGuid) {
  return function (dispatch) {
    dispatch(requestSubscriptions());
    return _SubscriptionsApiClient.default.fetchSubscriptions(formGuid).then(function (response) {
      dispatch(receiveSubscriptions(formGuid, response));
    }, function (error) {
      dispatch(errorSubscriptions(error.xhr));
    }).done();
  };
}

function fetchSubscriptionStatus(formGuid) {
  return function (dispatch) {
    dispatch(requestSubscriptionStatus());
    return _SubscriptionsApiClient.default.fetchSubscriptionStatus(formGuid).then(function (response) {
      dispatch(recieveSubscriptionStatus(formGuid, response));
    }, function (error) {
      dispatch(errorSubscriptionStatus(error.xhr));
    }).done();
  };
}

function fetchSubscriptionsIfNeeded(formGuid) {
  return function (dispatch, getState) {
    var subscriptionById = (0, _Subscriptions.getSubscriptionsByFormGuid)(getState())[formGuid];

    if (!(subscriptionById && subscriptionById.subscriptionsByEspListId)) {
      return dispatch(fetchSubscriptions(formGuid));
    }

    return _q.default.Promise.resolve();
  };
}

function fetchSubscriptionStatusIfNeeded(formGuid) {
  return function (dispatch, getState) {
    var subscriptionById = (0, _Subscriptions.getSubscriptionsByFormGuid)(getState())[formGuid];

    if (!(subscriptionById && subscriptionById.connectionStatus)) {
      return dispatch(fetchSubscriptionStatus(formGuid));
    }

    return _q.default.Promise.resolve();
  };
}

function updateSubscriptionEnabled(formGuid, espListId, syncEnabled) {
  return function (dispatch, getState) {
    var subscriptionById = (0, _Subscriptions.getSubscriptionsByFormGuid)(getState())[formGuid];

    if (subscriptionById) {
      var subscriptionByEspListId = subscriptionById.subscriptionsByEspListId[espListId];

      if (subscriptionByEspListId) {
        return dispatch(changeSubcriptionEnabled(formGuid, espListId, syncEnabled));
      }
    }

    return _q.default.Promise.resolve();
  };
}

function saveSubscriptions(formGuid, espListIds) {
  return function (dispatch, getState) {
    dispatch(submitSubscriptionChanges());
    var subscriptionsById = (0, _Subscriptions.getSubscriptionsByFormGuid)(getState())[formGuid];

    if (!subscriptionsById) {
      throw new Error("Can't save subscription, unknown form guid " + formGuid);
    }

    return _SubscriptionsApiClient.default.bulkUpdateSubscriptions(formGuid, Object.values((0, _underscore.pick)(subscriptionsById.subscriptionsByEspListId, espListIds) || {})).then(function (response) {
      dispatch(successSubscriptionChanges(formGuid, response));
    }, function (error) {
      dispatch(errorSubscriptionChanges(error.xhr));
      throw new Error('Error saving subscriptions');
    });
  };
}

function resetSubscriptions() {
  return function (dispatch) {
    dispatch(resetSubscriptionsAction());
  };
}

function fetchSubscriptionsDefinitions() {
  return function (dispatch) {
    dispatch(requestSubscriptionsDefinitions());
    return _SubscriptionsApiClient.default.getSubscriptionDefinitions().then(function (response) {
      dispatch(successSubscriptionDefinitions(response));
    }, function (error) {
      dispatch(errorSubscriptionsDefinitions(error));
    });
  };
}